import { appendElement } from '../../xml-helpers';
import {
  buildContributors,
  buildTitles,
  buildAbstracts,
  buildPublicationDates,
  buildPages,
  buildDoiData,
  buildSimilarityCheck,
  buildCitationList,
} from '../../builders';
import type { ConferencePaper } from '@generated/form-types/conference-proceeding';

/**
 * Appends a `<conference_paper>` element to the parent.
 */
export function buildConferencePaper(
  parent: Element,
  paper: ConferencePaper,
  removed: { simCheckUrl: boolean; references: boolean } = {
    simCheckUrl: false,
    references: false,
  }
): Element {
  const conferencePaper = appendElement(parent, 'conference_paper');

  // 1. contributors (optional)
  if (paper.contributors && paper.contributors.length > 0) {
    buildContributors(conferencePaper, paper.contributors);
  }

  // 2. titles
  buildTitles(conferencePaper, paper.paperTitle);

  // 3. abstracts (optional)
  buildAbstracts(conferencePaper, paper.abstracts);

  // 4. publication_date
  buildPublicationDates(conferencePaper, paper.publicationDates);

  // 5. pages (optional)
  buildPages(conferencePaper, paper.pageOrArticleNumber?.firstPageNumber);

  // 6. publisher_item (optional — article_number)
  if (paper.pageOrArticleNumber?.articleNumber) {
    const publisherItem = appendElement(conferencePaper, 'publisher_item');
    appendElement(
      publisherItem,
      'item_number',
      paper.pageOrArticleNumber.articleNumber,
      { item_number_type: 'article_number' }
    );
  }

  // 7. doi_data
  const doiData = buildDoiData(
    conferencePaper,
    paper.doi,
    paper.landingPageUrl
  );
  buildSimilarityCheck(
    doiData,
    removed.simCheckUrl ? undefined : paper.similarityCheckUrl,
    removed.simCheckUrl
  );

  // 8. citation_list (optional)
  buildCitationList(conferencePaper, paper.references, removed.references);

  return conferencePaper;
}
